"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * - To handle clicks add an `onClick` prop.
 * - Any props not listed will be passed through to the underlying element.
 */


var Button = function (_React$Component) {
  _inherits(Button, _React$Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          raised = _props.raised,
          dense = _props.dense,
          accent = _props.accent,
          className = _props.className,
          children = _props.children,
          link = _props.link,
          primary = _props.primary,
          unelevated = _props.unelevated,
          outlined = _props.outlined,
          buttonRef = _props.buttonRef,
          other = _objectWithoutProperties(_props, ["raised", "dense", "accent", "className", "children", "link", "primary", "unelevated", "outlined", "buttonRef"]);

      var T = link ? "a" : "button";
      return _react2.default.createElement(T, _extends({
        className: (0, _classnames2.default)("mdc-button", {
          "mdc-button--raised": raised,
          "mdc-button--dense": dense,
          "mdc-button--primary": primary,
          "mdc-button--unelevated": unelevated,
          "mdc-button--outlined": outlined
        }, className),
        ref: buttonRef
      }, other), children);
    }
  }]);

  return Button;
}(_react2.default.Component);

exports.default = Button;
Button.propTypes = {
  /** Primary button */
  primary: _propTypes.bool,

  /** Raised button. */
  raised: _propTypes.bool,

  /** Dense button. */
  dense: _propTypes.bool,

  /** Render the button as a link */
  link: _propTypes.bool,

  /** Flush with the surface */
  unelevated: _propTypes.bool,

  /** Flush with the surface with a visible border */
  outlined: _propTypes.bool,

  /** Pass a callback ref to get ref of underlying button DOM node */
  buttonRef: _propTypes.func
};
Button.defaultProps = {
  buttonRef: function buttonRef() {}
};